export const CONTEXT_DOCUMENT = {
  QUOTATION_REQUEST: 'QUOTATION_REQUEST',
  QUOTATION_UPDATE: 'QUOTATION_UPDATE',
  CONFIRMATION_UPLOAD: 'CONFIRMATION_UPLOAD',
  DEFAULT: 'DEFAULT',
} as const
